<template>
  <span class="benefits-tier-chip">
    <img v-if="option.svgSource" :src="option.svgSource" alt="" class="benefits-tier-chip-icon" />
    <span v-else-if="option.emoji" class="benefits-tier-chip-icon" aria-hidden="true">{{ option.emoji }}</span>
    {{ option.label }}
  </span>
</template>

<script>
export default {
  name: "BenefitsTierChip",
  props: {
    option: { type: Object, required: true },
  },
};
</script>

<style lang="scss" scoped>
.benefits-tier-chip {
  align-items: center;
  display: inline-flex;
  gap: 4px;
}

.benefits-tier-chip-icon {
  height: 16px;
  line-height: 16px;
  object-fit: contain;
  width: 16px;
}
</style>
